<div class="drop-zone flex-column" draggable="true" (click)="dropZoneClick()" [class.file-over]="fileOver" *ngIf="!file">
  <div>
    <i class="icon-stepper-add fs-40 text-primary"></i>
  </div>

  <span class="fs-15" *ngIf="!fileOver">Drop file here or click to select file</span>
  <span class="fs-15" *ngIf="fileOver">Drop file</span>
  <span class="fs-13 font-weight-light text-muted">({{ acceptedFileTypes }})</span>
  <input type="file" name="myFile" class="drop-zone-input" #fileInput (change)="onFileSelect($event.target.files)" [attr.accept]="acceptedFileTypes" />
</div>
<div class="d-flex align-items-center" *ngIf="file">
  <i class="icon-clip mr-2"></i>
  <div class="mr-auto mr-lg-5">{{ file.name }}</div>
  <a class="text-green cursor-pointer" (click)="deleteFile()">Delete</a>
</div>
